import { DashboardWidget } from '@adtrackify/at-tracking-event-types';
import { Layout } from 'react-grid-layout';

import { BREAKPOINT_TIER } from '@/features/dashboard/types/grid-enums';
import { DASHBOARD_DENSITY } from '@/features/dashboard/types/dashboard-density-enums';

import { packOrderPreservingLayout } from './pack-order-preserving-layout';

export function buildLayoutItemsForBreakpoint(
  widgets: DashboardWidget[],
  density: DASHBOARD_DENSITY,
  tier: BREAKPOINT_TIER
): Layout[] {
  return repackLayoutItemsForBreakpoint(widgets, density, tier);
}

export function repackLayoutItemsForBreakpoint(
  widgets: DashboardWidget[],
  density: DASHBOARD_DENSITY,
  tier: BREAKPOINT_TIER
): Layout[] {
  return packOrderPreservingLayout(widgets, density, tier);
}
